import history from '@/api/product/history'

import { baseState, baseMutations } from '@/store/mixins'


export const state = {
  ...baseState,
  locations: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  async listView(context, query) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      query
    )

    let response = await history.listView({ params })

    context.commit('RECEIVE_RESOURCES', response)
    return Promise.resolve(response)

  },
  getProductProfile(context, data){
    return history.getProductProfile(data)
  },
  exportToExcel(context, data){
    return history.toExcel(data)
  }
}